import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_COMMIT_PATH_KEY } from '@/swagger/constants/anagraphics-keys';
import {
  API_POST_EMPLOYEES_IMPORTS_CONFIRM,
  KEY_POST_EMPLOYEES_IMPORTS_CONFIRM,
} from '../constants';
import { MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_CONFIRM } from '../mocks';

type GenericPostConfirmImportedEmployees = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_COMMIT_PATH_KEY
>;

type RequestEmployeesImportsConfirm = GenericPostConfirmImportedEmployees['request']['path'];

export type CallParamsPostEmployeesImportsConfirm = Omit<
  RequestEmployeesImportsConfirm,
  'organizationId'
> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

type CallResponsePostEmployeesImportsConfirm =
  GenericPostConfirmImportedEmployees['response']['body'];

type CallErrorPostEmployeesImportsConfirm = GenericApiError;

type CallSelectorsPostEmployeesImportsConfirm = unknown;

export const postEmployeesImportsConfirmCall = createGeneralCall<
  CallParamsPostEmployeesImportsConfirm,
  CallResponsePostEmployeesImportsConfirm,
  CallErrorPostEmployeesImportsConfirm,
  CallSelectorsPostEmployeesImportsConfirm
>({
  id: KEY_POST_EMPLOYEES_IMPORTS_CONFIRM,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_EMPLOYEES_IMPORTS_CONFIRM(org as unknown as string, payload.jobId || '');
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED()
    ? (MOCK_RESPONSE_POST_EMPLOYEES_IMPORTS_CONFIRM as never)
    : (undefined as never),
});
